import { Box, Button, Grid2, Typography } from "@mui/material";
import Warning from "Components/Common/Warning";
import React, { useState } from "react";
import ModuleAnalytics from "./ModuleDetail/ModuleAnalytics";
import ModulesClasses from "./ModuleDetail/ModulesClasses";
import ResearchPaperDetail from "./ModuleDetail/ResearchPaperDetail";
import { useSelector } from "react-redux";

const styles = (theme) => ({
  border: `1px solid ${theme.palette.border.blue}`,
  borderRadius: "8px",
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  gap: "25px",
});

const ModuleClassDetail = () => {
  const [openResearchPaper, setOpenResearchPaper] = useState(false);

  const { Modules, Translation } = useSelector((state) => ({
    Modules: state.Course.modules,
    Translation: state.Translation.translation?.Course || {},
  }));

  return (
    Array.isArray(Modules) && Modules.length > 0 &&
    <Grid2 sx={styles}>
      <Warning showAlert={false}>
        <Box>
          <Typography>{`${Translation?.Pending} : ${Translation?.ReviewResearchPapers}`}</Typography>
          <Typography color="secondary.light">
            {Translation?.ReviewingResarchPapers}
          </Typography>
        </Box>
        <Button
          sx={{ marginLeft: "auto" }}
          variant="outlined"
          color="secondary"
          onClick={() => setOpenResearchPaper(true)}
        >
          {Translation?.GoToResearchPaper}
        </Button>
      </Warning>

      <ModuleAnalytics />
      <ModulesClasses />
      <ResearchPaperDetail
        open={openResearchPaper}
        setOpen={setOpenResearchPaper}
      />
    </Grid2>
  );
};

export default ModuleClassDetail;
